import React from 'react';

const SmartRequirement = () => {
    return (
        <div>
            SmartRequirement page
        </div>
    );
};

export default SmartRequirement;
